// Rótulos usados pelo editor de campanha v2.
import { CampaignTypesList } from "@/scripts/models/enums/campaignTypes.enum";

const PHASE_NAMES = Object.freeze({
	1: "Nova",
	2: "Em andamento",
	3: "Pausada",
	4: "Encerrada",
	5: "Cancelada",
});

// ProjectTypes e CampaignTypes compartilham a numeração no back.
const PROJECT_TYPE_NAMES = Object.freeze({
	1: "Incentivado",
	2: "Sem incentivo fiscal",
	3: "Ticket",
	4: "Voluntariado",
});

export function phaseName(phaseId) {
	return PHASE_NAMES[phaseId] || "—";
}

export function campaignTypeName(typeId) {
	const type = CampaignTypesList.find((item) => item.id === typeId);
	return type ? type.name : "—";
}

export function projectTypeName(typeId) {
	return PROJECT_TYPE_NAMES[typeId] || "—";
}

export function campaignPublicUrl(subdomain) {
	return subdomain ? `https://${subdomain}.abraceumacausa.com.br` : null;
}
